import React from 'react';

export type ActionStatus = 'good' | 'low' | 'high' | 'critical';

export interface ActionCardProps {
  title: string;
  currentValue: string;
  idealRange: string;
  status: ActionStatus;
  priority: number;
  children?: React.ReactNode;
}

const STATUS_COLORS: Record<ActionStatus, { border: string; bg: string; text: string; badge: string }> = {
  good: { border: 'border-green-500', bg: 'bg-green-900/30', text: 'text-green-400', badge: 'bg-green-500' },
  low: { border: 'border-yellow-500', bg: 'bg-yellow-900/30', text: 'text-yellow-400', badge: 'bg-yellow-500' },
  high: { border: 'border-orange-500', bg: 'bg-orange-900/30', text: 'text-orange-400', badge: 'bg-orange-500' },
  critical: { border: 'border-red-500', bg: 'bg-red-900/30', text: 'text-red-400', badge: 'bg-red-500' },
};

export const ActionCard: React.FC<ActionCardProps> = ({
  title, currentValue, idealRange, status, priority, children,
}) => {
  const c = STATUS_COLORS[status];
  return (
    <div className={`border ${c.border} ${c.bg} rounded-lg p-3 mb-3`}>
      <div className="flex justify-between items-center mb-1">
        <h4 className={`font-bold text-sm ${c.text}`}>{title}</h4>
        <span className={`text-xs ${c.badge} text-black font-bold px-1.5 py-0.5 rounded`}>
          P{priority}
        </span>
      </div>
      <p className="text-xs text-slate-400">
        Current: <span className="text-white font-semibold">{currentValue}</span>
        {' · '}
        Ideal: <span className="text-white font-semibold">{idealRange}</span>
      </p>
      {children}
    </div>
  );
};